import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { AdminComponent } from './admin/admin.component';

const routes: Route[] = [
    {
        component: AdminComponent,
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
        path: 'admin',
    },
];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'enabled',
    })],
})
export class AppRoutesModule {
    //
}
